import loadable from "@loadable/component";
import APIS from "../../constant/EndPoint";
import usePostHook from "../../customHooks/usePostHook";
import CreateIcon from "../../Icons/CreateIcon";
import { tw } from "@careinfo/tailwind";

const CreateCustomerComponent = loadable(
  () => import("../../components/Customer/CreateCustomer")
);

const CreateCustomer = () => {
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["customers"],
    navigateURL: "/",
  });

  const handleCreate = async (values: any, setError: any) => {
    const url = `${APIS.CUSTOMER}`;
    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <>
      <div className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}>
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Create Customer
        </span>
      </div>
      <CreateCustomerComponent
        isLoading={isPostLoading}
        handleCreate={handleCreate}
      />
    </>
  );
};

export default CreateCustomer;
